export const pobrespons_item = [
  {
    comparecencias_item_nombre: "Población SSH 2020",
    comparecencias_item_url: "../../../contenido/informacion/publicaciones/Población_SSH_2020.pdf",
    comparecencias_item_titulo: "Año 2020"
  },
  {
    comparecencias_item_nombre: "Población SSH 2024",
    comparecencias_item_url: "../../../contenido/informacion/publicaciones/Poblacion_SSH_2024.pdf",
    comparecencias_item_titulo: "Año 2024"
  },
  {
    comparecencias_item_nombre: "Población SSH 2025",
    comparecencias_item_url: "../../../contenido/informacion/publicaciones/Poblacion_SSH_2025.pdf",
    comparecencias_item_titulo: "Año 2025"
  },
];
